import React, { useEffect } from 'react'
import { makeStyles } from '@mui/styles'
import { Page } from 'components'
import { Typography } from '@mui/material'
import {
  Header
} from './components'
import { useDispatch } from 'react-redux'

const useStyles = makeStyles((theme) => ({
  root: {
    width: theme.breakpoints.values.lg,
    maxWidth: '100%',
    margin: '0 auto',
    padding: theme.spacing(3),
    [theme.breakpoints.up('lg')]: {
      paddingTop: theme.spacing(0)
    }
  },
  statistics: {
    [theme.breakpoints.down('md')]: {
      marginTop: theme.spacing(3)
    }
  },
  notifications: {
    marginTop: theme.spacing(3),
    [theme.breakpoints.down('md')]: {
      marginTop: theme.spacing(0),
      marginBottom: theme.spacing(3)
    }
  },
  summary: {
    marginTop: theme.spacing(3)
  },
  titleCard: {
    fontWeight: 500,
    flex: 1,
    fontSize: 16,
    marginTop: 30,
    marginLeft: 10
  }
}))

const Home = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
 
  return (
    <Page className={classes.root} title="Home">   
      <Header />
      <Typography component="h4" className={classes.titleCard}>
        FIDELIDADE
      </Typography>     
      <Typography component="h4" className={classes.titleCard} style={{ marginTop: 50 }}>
        PEDIDOS DE COMPRA
      </Typography>      
    </Page>
  )
}

export default Home
